export enum EGoalDatapointType {
    "GoalDatapoint",
    "WeeklyRateChange"
}
